module.exports = __webpack_public_path__ + "img/project-4.99997b35.jpg";